module.exports = __webpack_public_path__ + "static/logo-gray-svg-0a165ebee2b1f0a9fd5d353d2e15251d.svg";